var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("hotel-date-picker", {
        ref: "datepicker",
        attrs: {
          "first-day-of-week": 1,
          "show-year": true,
          lang: _vm.lang,
          format: "DD/MM/YYYY",
          "start-date": _vm.startDate,
          "end-date": _vm.endDate,
          "initial-check-in": _vm.initialCheckIn,
          "initial-check-out": _vm.initialCheckOut,
          "current-date-style": { border: "2px solid #bba640" },
          "display-clear-button": _vm.displayClearButton,
          "hovering-tooltip": _vm.hoveringTooltip,
          "disable-dates-without-price": _vm.disableDatesWithoutPrice,
          "disabled-dates": _vm.disabledDates,
          "price-by-date": _vm.priceByDate,
          "min-nights-by-date": _vm.minNightsByDate
        },
        on: {
          "check-in-changed": _vm.updateCheckIn,
          "check-out-changed": _vm.updateCheckOut
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }